import Vue from "vue";
import featureToggling from "./feature-toggling";
import experiments from "./experiments";
import devices from "./devices";
import pages from "./pages";

const mixins = [featureToggling, experiments, devices, pages];
mixins.forEach((mixin) => Vue.mixin(mixin));
